import React from "react";

const Instructor = ({ selectedCourse }) => {
  return (
    <div className="w-full">
      <h2 className="text-[#22BEFF] text-2xl font-bold">কোর্স ইন্সট্রাক্টর</h2>
      <div className="w-full border border-[#22BEFF33] mt-[1rem] rounded-md grid grid-cols-1 gap-8 p-4">
        {selectedCourse?.course_intructor?.map((items, index) => (
          <div className="flex gap-4" key={index}>
            {/* If you have image data available, uncomment and use the line below */}
            <img src={`${import.meta.env.VITE_API_BASE_URL}/storage/${items?.image}`} alt={items?.name} className='w-[6rem] h-[6rem] rounded-md'/>

            <div className="flex flex-col">
              <span className="text-xl text-gray-400 font-bold">
                {items?.name}
              </span>
              <span className="text-xl text-gray-400">{items?.education}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Instructor;
